export default __webpack_public_path__ + "static/media/ban-mobile-image-8.326d2d9f.jpg";